module.exports = __webpack_public_path__ + "static/media/thiland.ef412b11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/thiland.jpg
// module id = 37
// module chunks = 0